import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import DeviceAppearanceNew from 'client/components/core/Sidebar/components/Settings/options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { MarginType } from 'common/types/styleTypes'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { BookingPaidCalendarStepsSwitcher } from './booking-paid-calendar-steps-switcher'

export interface BookingCalendarSettingsProps {
  entity: BookingPaidCalendarInterface
}

export const BookingPaidCalendarSettings = ({
  entity,
}: BookingCalendarSettingsProps) => {
  const updateProp = useUpdateProp(entity)
  const { isMobile } = useDeviceModeContext()

  return (
    <React.Fragment>
      <BookingPaidCalendarStepsSwitcher entity={entity} />
      <SizeAndPositionGroup
        padding={isMobile ? entity?.mobilePadding : entity.padding}
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={value =>
          updateProp(isMobile ? 'mobileMargin' : 'margin')(value as MarginType)
        }
      />
      <GroupTitle>color</GroupTitle>
      <ColorPickerControl
        update={updateProp('titlesColor')}
        mobileUpdate={updateProp('mobileTitlesColor')}
        color={entity.titlesColor}
        mobileColor={entity.mobileTitlesColor}
        label={'entity_settings.calendar.titles_color'}
      />
      <ColorPickerControl
        update={updateProp('color')}
        mobileUpdate={updateProp('mobileColor')}
        color={entity.color}
        mobileColor={entity.mobileColor}
        label={'entity_settings.calendar.text_color'}
        isClearable
      />
      <ColorPickerControl
        update={updateProp('availableSlotBackgroundColor')}
        color={entity.availableSlotBackgroundColor}
        label={'entity_settings.calendar.available_slot_bg_color'}
        singleColorMode
      />
      <ColorPickerControl
        update={color => {
          updateProp('selectedSlotBackgroundColor')(color)
        }}
        color={entity.selectedSlotBackgroundColor}
        label={'entity_settings.calendar.selected_slot_bg_color'}
        singleColorMode
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </React.Fragment>
  )
}
